<span *ngIf="showName">{{ colorDescriptor }}: </span
><i
    class="fa-solid fa-circle"
    [class]="colorClass"
></i>
